(function () {

    'use strict';

    angular.module('Services').factory('ManifestShipmentsTable', ManifestShipmentsTable);

    function ManifestShipmentsTable(ManifestService, TableLiteFactory, $filter, toastr, $uibModalStack, Shipments) {
        return function (serviceDetailsList, manifestId) {

            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };
            let ShipmentsTableData = {
                tableName: 'ManifestShipmentsTable',
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: '+ ADD NEW',
                        onClick: function () {

                        }
                    }]
                },*/
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtraction: true,
                    colMinWidth: '135px',
                    tableHeight: '400px'
                },
                headers: [{
                    label: 'DATE RANGE',
                    viewName: 'createdDate',
                    filterName: 'createdDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: '',
                        fromModel: '',
                        useArray: true,
                        onSubmit: function (header) {

                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        class: 'filter-consignment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: 'companyName',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: ' Office/Location',
                    viewName: 'locationName',
                    filterName: 'locationName',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Account',
                    viewName: 'accountEmail',
                    filterName: 'user.email',
                    filter: {
                        type: 'text',
                        class: 'filter-account',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BOOKING STATUS',
                    viewName: 'bookingStatus',
                    filterName: 'bookingStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        /*items: [{
                         value: 'new',
                         viewName: 'New'
                         }, {
                         value: 'pending',
                         viewName: 'Pending'
                         }, {
                         value: 'unprocessed',
                         viewName: 'Unprocessed'
                         }, {
                         value: 'inprogress',
                         viewName: 'In Progress'
                         }, {
                         value: 'processed',
                         viewName: 'Processed'
                         }],*/
                        items: [{
                            value: 'pending',
                            viewName: 'Awaiting Booking'
                        }, {
                            value: 'inprogress',
                            viewName: 'Processing'
                        }, {
                            value: 'processed',
                            viewName: 'Completed'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'TRACKING NO.',
                    viewName: 'trackingNumber',
                    filterName: 'trackingNumber',
                    filter: {
                        type: 'text',
                        class: 'filter-tracking-number',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'THIRD PARTY REFERENCE NO.',
                    viewName: 'wmsReference',
                    filterName: 'wmsReference',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER REF NO.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Linked Job',
                    viewName: 'jobId',
                    filterName: 'job.id',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Source Address',
                    viewName: 'sourceAdd'
                }, {
                    label: 'Destination Address',
                    viewName: 'destinationAdd'
                }, {
                    label: 'AMOUNT EX TAX',
                    viewName: 'amount'
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: function () {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                },
                rowOnClick: rowClick,
            };

            function rowClick(){
                $uibModalStack.dismissAll();
            }
            
            const tableActions = new TableLiteFactory(ShipmentsTableData,
                {
                    serviceCallback: ManifestService.getShipments,
                    paramId: manifestId,
                    callbackFormat: ['success','error','filter', 'id'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc'
                    }
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/

                if (!data)
                    return ShipmentsTableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.createdDate = $filter('bbaDate')(item.createdDate);
                    item.companyName = item.company.name || 'N/A';
                    item.locationName = item.office.name ? item.office.name : 'N/A';
                    item.accountEmail = item.user.email || 'N/A';
                    item.trackingNumber = item.trackingNumber ? item.trackingNumber : 'N/A';
                    item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                    item.wmsReference = item.wmsReference || 'N/A';
                    if (item.serviceDetails) {
                        item.carrierName = {
                            type: 'logotype',
                            imgSrc: item.serviceDetails.logo
                        };
                        item.serviceName = item.serviceDetails.serviceName;
``                    }
                    item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                    item.bookingStatus = bookingStatuses[item.bookingStatus]; // Define Booking Status
                    
                    if (item.customerReferences.length > 0) {
                        const items = angular.copy(item.customerReferences);
                        item.customerReferences = {
                            type: 'multiLine',
                            list: items
                        };
                    } else {
                        item.customerReferences = 'N/A';
                    }
                    
                    item.href = '/shipments/view/' + item.id;
                    item.sourceAdd = {
                        type: 'multiLine',
                        list:[
                            item.sourceAddress.addressLine1,
                            item.sourceAddress.addressLine2,
                            `${angular.getObjVal(item,'sourceAddress.location.name')}, `+
                            `${angular.getObjVal(item, 'sourceAddress.location.state.code') || angular.getObjVal(item, 'sourceAddress.location.state.name')}`+
                            `${item.sourceAddress.location.code ? '-' + item.sourceAddress.location.code : ''}, `+
                            `${angular.getObjVal(item, 'sourceAddress.location.country.code')}`
                        ]
                    };
                    item.destinationAdd = {
                        type: 'multiLine',
                        list:[
                            item.destinationAddress.addressLine1,
                            item.destinationAddress.addressLine2,
                            `${angular.getObjVal(item,'destinationAddress.location.name')}, `+
                            `${angular.getObjVal(item, 'destinationAddress.location.state.code') || angular.getObjVal(item, 'destinationAddress.location.state.name')}`+
                            `${item.destinationAddress.location.code ? '-' + item.destinationAddress.location.code : ''}, `+
                            `${angular.getObjVal(item, 'destinationAddress.location.country.code')}`
                        ]
                    };
                    ShipmentsTableData.data.push(item);
                });
            }
            this.tableData = ShipmentsTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ManifestShipmentsTableService.js